import React from 'react';
import SvgIcon from "../../../common/SvgIcon";

const ReviewsIoWidget = () => (
  <div className="brief_rating-container">
    <a
      href="https://www.reviews.co.uk/company-reviews/store/mybespokeroom-com"
      rel="noopener noreferrer"
      target="_blank">
      <span><strong>Rated Excellent &nbsp;&nbsp;&nbsp;4.9 / 5</strong></span>
      <p className="reviewsText">
        <SvgIcon icon="reviews_io_stars" className="starsImg" />
        <SvgIcon icon="reviews.io" className="logo" />
      </p>
    </a>
  </div>
);

export default ReviewsIoWidget;



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/ReviewsIoWidget.js